var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { gql, useMutation, useApolloClient, } from '@apollo/client';
import { OnboardingStep } from '../../../types/GloblalTypes';
import { GET_COMPLETED_ONBOARDING_STEPS_QUERY, useGetCompletedTeamAccountOnboardingStepsQuery, } from './useGetCompletedOnboardingStepsQuery';
import { useIsDynamicBooleanEnabled } from '../../DynamicValues/hook';
import { DYNAMIC_VALUES_NAME } from '../../DynamicValues';
import { useSelector } from 'react-redux';
import { getMembers } from '../../../selectors/members_selector';
import { getTeamAccountBudgets } from '../../../selectors/budgets_selector';
import { TEAM_ACCOUNT_PAYER_PAYMENT_METHOD_QUERY } from '../../Billing/PaymentCard/usePaymentCardQuery';
export var SET_TEAM_ACCOUNT_ONBOARDING_STEP_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation setTeamAccountOnboardingStep(\n    $teamAccountId: String!\n    $step: OnboardingStep!\n  ) {\n    setTeamAccountOnboardingStep(teamAccountId: $teamAccountId, step: $step) {\n      steps\n    }\n  }\n"], ["\n  mutation setTeamAccountOnboardingStep(\n    $teamAccountId: String!\n    $step: OnboardingStep!\n  ) {\n    setTeamAccountOnboardingStep(teamAccountId: $teamAccountId, step: $step) {\n      steps\n    }\n  }\n"])));
export var useGetReduxData = function () {
    var _a;
    var _b, _c;
    var members = (_b = useSelector(getMembers)) !== null && _b !== void 0 ? _b : [];
    var budgets = (_c = useSelector(getTeamAccountBudgets)) !== null && _c !== void 0 ? _c : [];
    return _a = {},
        _a[OnboardingStep.ONBOARDING_STEP_ADD_MEMBER] = members,
        _a[OnboardingStep.ONBOARDING_STEP_ADD_BUDGET] = budgets,
        _a;
};
export var useGetApollCacheData = function (teamAccountId) {
    var _a;
    var _b;
    var client = useApolloClient();
    var data = client.readQuery({
        query: TEAM_ACCOUNT_PAYER_PAYMENT_METHOD_QUERY,
        variables: {
            teamAccountId: teamAccountId,
        },
    });
    var paymentCards = (_b = data === null || data === void 0 ? void 0 : data.getPaymentMethodListByTeamAccount) !== null && _b !== void 0 ? _b : [];
    return _a = {},
        _a[OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD] = paymentCards,
        _a;
};
/** pageData check is not used temporaily
 * we set a step when the selected onboarding step is not complete yet
 */
export var useCheckSelectedPageData = function (teamAccountId, onboardingStep) {
    var pageData = useGetReduxData();
    var pageDataInCache = useGetApollCacheData(teamAccountId);
    var hasPageData = false;
    var data = [];
    switch (onboardingStep) {
        case OnboardingStep.ONBOARDING_STEP_ADD_MEMBER:
            data = pageData[OnboardingStep.ONBOARDING_STEP_ADD_MEMBER];
            // has one admin and at least one added member
            var hasAddedMembers = data.length >= 2;
            hasPageData = hasAddedMembers;
            break;
        case OnboardingStep.ONBOARDING_STEP_ADD_BUDGET:
            data = pageData[OnboardingStep.ONBOARDING_STEP_ADD_BUDGET];
            // has one or more added budgets
            var hasAddedBudget = data.length >= 1;
            hasPageData = hasAddedBudget;
            break;
        case OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD:
            data = pageDataInCache[OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD];
            // has one or more added payment cards
            var hasAddedPayment = data.length >= 1;
            hasPageData = hasAddedPayment;
            break;
        case OnboardingStep.ONBOARDING_STEP_FINISH_ONBOARDING:
            // finish onboarding step - page data is not required
            hasPageData = false;
            break;
        default:
            data = [];
    }
    return hasPageData;
};
export var useShouldOperationSetOnboardingStep = function (teamAccountId, toDoStep) {
    var _a, _b, _c, _d;
    var isSelfServeOnboardingEnabled = useIsDynamicBooleanEnabled(DYNAMIC_VALUES_NAME.ddfwSelfServeOnboarding);
    // check cache for the list of completed tasks
    var data = useGetCompletedTeamAccountOnboardingStepsQuery(teamAccountId).data;
    if (!isSelfServeOnboardingEnabled) {
        return false;
    }
    var hasCompletedStep = data &&
        (((_b = (_a = data.getCompletedTeamAccountOnboardingSteps) === null || _a === void 0 ? void 0 : _a.steps) === null || _b === void 0 ? void 0 : _b.includes(toDoStep)) || ((_d = (_c = data.getCompletedTeamAccountOnboardingSteps) === null || _c === void 0 ? void 0 : _c.steps) === null || _d === void 0 ? void 0 : _d.includes(OnboardingStep.ONBOARDING_STEP_FINISH_ONBOARDING)));
    return !hasCompletedStep;
};
export var useSetOnboardingStepMutation = function (teamAccountId, step, options) {
    var shouldSetStep = useShouldOperationSetOnboardingStep(teamAccountId, step);
    var _a = __read(useMutation(SET_TEAM_ACCOUNT_ONBOARDING_STEP_MUTATION, __assign({ variables: {
            teamAccountId: teamAccountId,
            step: step,
        }, fetchPolicy: (options === null || options === void 0 ? void 0 : options.fetchPolicy) || 'network-only', refetchQueries: [
            {
                query: GET_COMPLETED_ONBOARDING_STEPS_QUERY,
                variables: { teamAccountId: teamAccountId },
            },
        ] }, options)), 1), setStep = _a[0];
    return {
        setOnboardingStep: function () {
            if (shouldSetStep) {
                setStep();
            }
        },
    };
};
var templateObject_1;
